import React from "react";

import selectedActions from "../../../img/selected-actions-arrow.svg";
import { Svg } from "../../../utils/svgIcon";

import { TextTool } from "./TextTool";
import * as theme from "./Toolbar.css";
import { ToolbarSpacer } from "./ToolbarSpacer";

interface TableToolbarSelection {
    count: number;
    label: string;
}

interface TableToolbarProps {
    selection?: TableToolbarSelection;
    children?: React.ReactNode;
}

export function TableToolbar({ selection, children }: TableToolbarProps) {
    return (
        <div className={theme.reactableToolbarContainer}>
            <div className={theme.reactableToolbar}>
                <Svg className={theme.imageDivider} src={selectedActions} />
                {selection && (
                    <span
                        className={
                            selection.count > 0
                                ? theme.selectionLabel.some
                                : theme.selectionLabel.none
                        }
                    >
                        {selection.label}
                    </span>
                )}
                {children}
            </div>
        </div>
    );
}

export { ToolbarSpacer, TextTool };
